var productName = 'grid';export const RowsRange = {
    all     : 'all',
    visible : 'visible'
};
export const PaperFormat = {
    A6 : {
        width  : 4.11,
        height : 5.81
    },
    A5 : {
        width  : 5.81,
        height : 8.25
    },
    A4 : {
        width  : 8.25,
        height : 11.69
    },
    A3 : {
        width  : 11.69,
        height : 16.49
    },
    Legal : {
        width  : 8.5,
        height : 14
    },
    Letter : {
        width  : 8.5,
        height : 11
    }
};
export const Orientation = {
    portrait  : 'portrait',
    landscape : 'landscape'
};
export const FileFormat = {
    pdf : 'pdf',
    png : 'png'
};
export const FileMIMEType = {
    pdf : 'application/pdf',
    png : 'image/png'
};
